import {
  ValidationErrors,
  ValidatorFn,
  FormGroup,
  AbstractControl,
  FormControl
} from '@angular/forms';

export function stateValidator(states): ValidatorFn {
  return (control: AbstractControl) => {
    if (!states || states.length === 0) {
      return {
        stateValid: true
      };
    }
    return null;
  };
}
